import React, { useState } from "react";
import ImportVehicles from "../../import/ImportVehicles";
import StyledDrawer from "../StyledDrawer";

export default function VehiclesUploadDialog({
  open,
  setCurrentAction,
  handleClose,
  setUploadOpen
}) {
  const goBack = () => {
    setCurrentAction("overview");
  };

  const [loadingImport, setLoadingImportLeft] = useState(false);

  return (
    <StyledDrawer open={open} handleClose={handleClose} loading={loadingImport}>
      <ImportVehicles
        loadingImport={false}
        setUploadOpen={setUploadOpen}
        setLoadingImportLeft={setLoadingImportLeft}
        handleClose={goBack}
      />
    </StyledDrawer>
  );
}
